import AppRoutes from "./routes/AppRoutes";

// 🔥 Redux
import { Provider, useDispatch } from "react-redux";
import { store } from "./store";

// 🔥 Global Snackbar
import GlobalSnackbar from "./components/common/GlobalSnackbar";

// 🔥 logout action
import { logout } from "./store/authSlice";
import { useEffect } from "react";

// 🔥 Wrapper for logout sync
const AppWrapper = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleLogout = () => {
      dispatch(logout());
    };

    window.addEventListener("logout", handleLogout);

    return () => {
      window.removeEventListener("logout", handleLogout);
    };
  }, [dispatch]);

  return (
    <>
      <GlobalSnackbar />
      <AppRoutes />
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <AppWrapper />
    </Provider>
  );
}

export default App;